export default __webpack_public_path__ + "static/media/Help_Assistant_filled.f81c2c61.svg";